
































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import AppConsts from '@/lib/appconst';
import VueBarcode from 'vue-barcode';
import Print from 'vue-print-nb'
Vue.use(Print);
@Component({
    components:{ 'barcode': VueBarcode}
})
export default class PrinterShippingLabelOfGroup extends AbpBase{
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 1 }) width: number;
  @Prop({ type: Number, default: 30 }) height: number;
  @Prop({ type: String, default: "svg" }) type: String;
  @Prop({ type: String, default: "Arial" }) font: String;
  @Prop({ type: String, default: "12" }) fontSize: String;
  options:any= {
      format: 'CODE128',
      background: '#fff'
  }
  groupPackageNo : string = '';

  get shippingLabel(){
    var re = this.$store.state.saleOrder.shippingLabel;
    return re;
  }
  get urlLogo() {
        return abp.setting.get(AppConsts.warehouseLogo);
    }
  async created() {
    this.groupPackageNo = this.$root.$router.currentRoute.params.groupPackageNo;
    await this.$store
      .dispatch({
          type:'saleOrder/getShippingLabelOfGroup',
          data: { groupPackageNo : this.groupPackageNo }
      });
  }
}
